import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import type { ReviewDto, ReviewsResponse } from '../models/restaurant-api.model';

@Injectable({ providedIn: 'root' })
export class ReviewsService {
  private readonly http = inject(HttpClient);

  getReviews(): Observable<ReviewDto[]> {
    return this.http.get<ReviewsResponse>(`${environment.apiUrl}/api/reviews`).pipe(
      map((res) => res?.reviews ?? []),
      catchError(() => of([]))
    );
  }
}
